import { IsNotEmpty, IsIn, IsNumber } from "class-validator";
import { Constants } from "@eagerdog/constants";

import { IEventArmNumberConfig } from "./event-arm-number-config.interface";

export class EventArmNumberConfigDto implements IEventArmNumberConfig {
  @IsNotEmpty()
  @IsIn(Object.values(Constants.show_type))
  show_type: string;

  @IsNotEmpty()
  @IsNumber()
  arm_number_start: number;
}
